import { memo } from 'react'

import customConfig from 'customConfig'

import { COLOR_ERROR } from '../../../constants/theme'
import Popup from '../../shared/popup/Popup'

const FailedStatus = ({
  onSubmit,
  title,
  description,
  icon,
  color,
  t,
  customSubmitLabel,
  onCancel
}) => (
  <Popup
    title={title}
    description={description}
    icon={icon}
    color={color || COLOR_ERROR}
    submitLabel={t(customSubmitLabel || customConfig.tryAgainLabel)}
    onFormSubmit={onSubmit}
    onCancel={onCancel}
  />
)

export default memo(FailedStatus)
